import Vue from 'vue'
import Router from 'vue-router'
import VueMeta from 'vue-meta'
// import Home from '@/components/Home'
// import Menu from '@/components/Menu'
// import About from '@/components/About'
// import Gallery from '@/components/Gallery'
// import NotFound from '@/components/NotFound'
const Home = () => import('@/components/Home')
const Menu = () => import('@/components/Menu')
const About = () => import('@/components/About')
const Gallery = () => import('@/components/Gallery')
const NotFound = () => import('@/components/NotFound')

Vue.use(Router)
Vue.use(VueMeta)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/404',
      component: NotFound
    },
    {
      path: '*',
      redirect: '/404'
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/home',
      redirect: '/'
    },
    {
      path: '/menu',
      name: 'Menu',
      component: Menu
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/gallery',
      name: 'Gallery',
      component: Gallery
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js